export const saveButtonVersions = { classic: "classic", heart: "heart" };
